import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./../consultaNominas/consultaNominas.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import Button from "../../../atoms/buttons/Button";

registerLocale("es", es);

const ModalPresentar = (object) => {
  
  
  const [token] = useLocalStorage("token", "");
  const [showConfirm] = useState(false);

  useEffect(() => {}, [token]);

  function modalPresenta() {
    return (
      <Modal
        className={`infModal fechas ${
          showConfirm ? "opacity-0" : "opacity-100"
        } `}
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
            {/* <Titulo titulo="Respuesta" tipo="text-center tituloModal" /> */}
            <h4 className="tituloModal text-center">Respuesta</h4>
            <p className="fs-3">
              Ya tiene una solicitud presentada. Si continua con el proceso se
              sustituirá por esta nueva presentación.{" "}
            </p>
            <span className="fw-bold fs-3">¿Estás seguro/a?</span>{" "}
          </div>

          <Button
            id="btnAceptar"
            clases="btn-card mt-2 rounded"
            nombre={"Aceptar"}
            funcion={() => {
              object.peguntaPresentar(object.valores);
            }}
          />
          <Button
            id="btnDenegar"
            clases="btn-card bg-danger mt-2 rounded"
            nombre={"Denegar"}
            funcion={() => {
              object.handleClose();
            }}
          />
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalPresenta()}</>;
};

export default memo(ModalPresentar);
